import React, { useRef, useState } from "react"
import BaseScreen from "../BaseScreen"
import { MainNavProps } from "../navigation/main/MainParamList"
import {
    Str_Account,
    Str_Cancel,
    Str_ChatRecord,
    Str_Contacts,
    Str_GroupChat,
    Str_Include,
    Str_MoreChatRecord,
    Str_MoreContacts,
    Str_Nick,
    Str_RelatedChatRecords,
    Str_Search,
    Str_NoSpacesAllowed,
} from "../../language/string_res"
import { ColorLine, color_333333, color_999999, color_BEBEBE, color_EEF2F9, color_main, white } from "../../assets/style/colors"
import {
    ActivityIndicator,
    Image,
    Keyboard,
    Pressable,
    SectionList,
    StyleSheet,
    Text,
    TextInput,
    TouchableOpacity,
    View
} from "react-native"
import { ImageView } from "../../components/ImageView"
import { useStore } from "../../store/UserStore"
import { User } from "../../../imsdk/db/t_user";
import { getUserName, useNavigationToChatView2 } from "./chat-helper"
import { LeftView } from "./CListItem"
import * as ImSdk from "../../../imsdk/api";
import { Avatar, TopicWithSummary } from "../../../imsdk/api/topic"
import { toSingleChat } from "../Contact/CreateChat"
import { GroupMember } from "../../../imsdk/db/t_group_member"
import time from "../../../imsdk/time"
import { isGroupTopic } from "../../utils/utils"
import { buildSingleTopicId, parseSingleOther } from "../../utils/helper"
import { Group } from "../../../imsdk/db/t_group"
import { ListEmpty } from "../../components/ListEmpty"
import { ScreenCloseModal } from "../../components/ScreenModal"
import { ChatSearchInput } from "./components/ChatSearchInput"
import { showToast } from "../../components/Toast"

type ChatSearchData = {
    title: string;
    footer: string;
    type: string;
    data: { subText: string, data: any }[];
};
let searchTimer: any = null
let users: { data: User, subText: string }[] = []
let groups: { data: Group, subText: string }[] = []
let msgs: { data: { tid: string, data: Group | User }, subText: string }[] = []

export const Div = () => (
    <View style={{ backgroundColor: ColorLine, height: 0.5, marginHorizontal: 12 }} />
);

export const CommonText = (name: string, subText: string) => (
    <View style={{ alignItems: 'center', flex: 1 }}>
        <Text style={styles.userTitle}>{name}</Text>
        {subText.length > 0 ? <Text style={styles.subUserTitle}>{subText}</Text> : null}
    </View>
);
export const SectionHeader = ({ title }: { title: string }) =>
(
    <View style={{
        backgroundColor: white,
    }}>
        <Text style={styles.header}>{title}</Text>
        <Div />
    </View>
)


export const ChatSearch = ({ navigation }: MainNavProps<'ChatSearch'>) => {
    const [searchText, setSearchText] = useState('')
    const [section, setSection] = useState<ChatSearchData[]>([]);
    const { state } = useStore();
    const toChatView = useNavigationToChatView2();
    const [isLoading, setIsLoading] = useState(false);
    const im = ImSdk.getInstance();
    /** 每次新输入或清空时递增，用于丢弃过期的 Promise.all 结果 */
    const searchSeqRef = useRef(0);

    const onChangeText = (text: string) => {
        if (text.includes(' ')) {
            showToast(Str_NoSpacesAllowed)
            text = text.trim()
        }
        if (searchTimer) {
            clearTimeout(searchTimer);
            searchTimer = null;
        }
        setSearchText(text)
        if (!text || text.length === 0) {
            searchSeqRef.current += 1
            setIsLoading(false)
            setSection([])
            return
        }
        searchSeqRef.current += 1
        const seq = searchSeqRef.current
        setIsLoading(true)
        setSection([])
        searchTimer = setTimeout(() => {
            startSearch(text, seq)
        }, 280);
    }

    const startSearch = (text: string, seq: number) => {
        if (seq !== searchSeqRef.current) {
            return
        }
        setIsLoading(true)
        const sections: ChatSearchData[] = []
        if (text.length === 0) {
            setIsLoading(false)
            setSection(sections)
            return
        }

        function contactsFilterDeleted() {
            const c = state?.contactList ?? []
            const result: User[] = []
            c.forEach((value) => {
                const b1 = value.status !== 'deleted'
                if (b1) {
                    result.push(value)
                }
            })

            return result
        }

        const doSearch = async () => {
            const filterUser = contactsFilterDeleted();
            let data: { data: User, subText: string }[] = [];
            if (text && text.length > 0) {
                const n = filterUser.length
                for (let i = 0; i < n; i++) {
                    const user = filterUser[i]
                    if (user.remark && user.remark.toLowerCase().includes(text.toLowerCase())) {
                        data.push({ data: user, subText: '' })
                        continue
                    }
                    if (user.nick && user.nick.toLowerCase().includes(text.toLowerCase())) {
                        data.push({ data: user, subText: `${Str_Nick}：${user.nick}` })
                        continue
                    }
                    if (user.remarkPY && user.remarkPY.toLowerCase().includes(text.toLowerCase())) {
                        data.push({ data: user, subText: '' })
                        continue
                    }
                    if (user.nickPY && user.nickPY.toLowerCase().includes(text.toLowerCase())) {
                        data.push({ data: user, subText: `${Str_Nick}：${user.nick}` })
                        continue
                    }
                    // 需求变更，去掉手机号和邮箱的联系人搜索
                    // if (user.email && user.email.toLowerCase().includes(text.toLowerCase())) {
                    //     data.push({ data: user, subText: `${Str_Account}：${user.email}` })
                    //     continue
                    // }
                    // if (user.telno && user.telno.toLowerCase().includes(text.toLowerCase())) {
                    //     data.push({ data: user, subText: `${Str_Account}：${user.telno}` })
                    // }
                }
            }
            const length = data.length
            users = data
            data = length <= 3 ? data : data.slice(0, 3)
            if (data.length > 0) {
                const item: ChatSearchData = {
                    title: Str_Contacts,
                    footer: length > 3 ? Str_MoreContacts : '',
                    type: "Contact",
                    data: data
                }
                sections.push(item)
            }

        };

        const searchGroup = async () => {
            let data: { data: Group, subText: string }[] = [];

            function filterMember(group: Group, members: GroupMember[]) {
                const n = members.length
                for (let i = 0; i < n; i++) {
                    const user = members[i]
                    if (user.remark && user.remark.toLowerCase().includes(text.toLowerCase())) {
                        data.push({ data: group, subText: `${Str_Include}：${user.remark}` })
                        break
                    }
                    if (user.nick && user.nick.toLowerCase().includes(text.toLowerCase())) {
                        data.push({ data: group, subText: `${Str_Include}：${user.nick}` })
                        break
                    }
                    if (user.nickPY && user.nickPY.toLowerCase().includes(text.toLowerCase())) {
                        data.push({ data: group, subText: `${Str_Include}：${user.nick}` })
                        break
                    }
                    // 需求变更，去掉手机号和邮箱的群成员搜索
                    // if (user.email && user.email.toLowerCase().includes(text.toLowerCase())) {
                    //     const name = user.remark || user.nick || ''
                    //     const text = name.length > 0 ? `${Str_Include}：${name}(${user.email})` : `${Str_Include}：${user.email}`
                    //     data.push({ data: group, subText: text })
                    //     break
                    // }
                    // if (user.telno && user.telno.toLowerCase().includes(text.toLowerCase())) {
                    //     const name = user.remark || user.nick || ''
                    //     const text = name.length > 0 ? `${Str_Include}：${name}(${user.telno})` : `${Str_Include}：${user.telno}`
                    //     data.push({ data: group, subText: text })
                    //     break
                    // }
                }
            }

            const res = await ImSdk.getInstance().GetGroupSummaryList(false)
            if (res.groupSummarys && res.groupSummarys.length > 0) {
                const n = res.groupSummarys.length
                const q = text.toLowerCase()
                for (let i = 0; i < n; i++) {
                    const summary = res.groupSummarys[i]
                    const r = await ImSdk.getInstance().GetGroupLocal(summary.tid)
                    if (r.group && (r.group.remark ?? "").toLowerCase().includes(q)) {
                        data.push({ data: r.group, subText: '' })
                    } else if (r.group && (r.group.name ?? "").toLowerCase().includes(q)) {
                        data.push({ data: r.group, subText: '' })
                    } else {
                        if (r.group && r.members) {
                            filterMember(r.group, r.members)
                        }
                    }
                }
                const l = data.length
                groups = data
                data = l <= 3 ? data : data.slice(0, 3)
                if (data.length > 0) {
                    const item: ChatSearchData = {
                        title: Str_GroupChat,
                        footer: l > 3 ? Str_MoreContacts : '',
                        type: "GroupList",
                        data: data
                    }
                    sections.push(item)
                }
            }

        }
        const searchMsg = async () => {
            let data: { data: { tid: string, data: Group | User }, subText: string }[] = [];

            async function loadGroupForRecord(tid: string, total: number) {
                const r = await ImSdk.getInstance().GetGroupLocal(tid)
                if (r.group) {
                    data.push({ data: { tid: tid, data: r.group }, subText: `${total}${Str_RelatedChatRecords}` })
                }
            }

            async function GetUserDetail(tid: string, total: number) {
                const uid = parseSingleOther(tid)
                if (uid > 0) {
                    const r = await ImSdk.getInstance().GetUser(uid, true)
                    if (r.user) {
                        data.push({ data: { tid: tid, data: r.user }, subText: `${total}${Str_RelatedChatRecords}` })
                    }
                }
            }

            const r = await ImSdk.getInstance().QueryMsg(text, time.toUnixMillSecond(time.now()))
            if (r.data && r.data.length > 0) {
                const n = r.data.length
                for (let i = 0; i < n; i++) {
                    const item = r.data[i]
                    const isGroup = isGroupTopic(item.tid)
                    if (isGroup) {
                        await loadGroupForRecord(item.tid, item.total)
                    } else {
                        await GetUserDetail(item.tid, item.total)
                    }
                }

                const l = data.length
                msgs = data
                data = l <= 3 ? data : data.slice(0, 3)
                if (data.length > 0) {
                    const item: ChatSearchData = {
                        title: Str_ChatRecord,
                        footer: l > 3 ? Str_MoreChatRecord : '',
                        type: "Records",
                        data: data
                    }
                    sections.push(item)
                }
            }

        }
        const search1 = doSearch()
        const search2 = searchGroup()
        const search3 = searchMsg()
        const applyIfCurrent = () => {
            if (seq !== searchSeqRef.current) {
                return
            }
            setSection(sections)
            setIsLoading(false)
        }
        Promise.all([search1, search2, search3]).then(applyIfCurrent).catch(() => {
            if (seq !== searchSeqRef.current) {
                return
            }
            setIsLoading(false)
        })
    }

    const SectionFooter = ({ section: { footer, type, data } }: { section: ChatSearchData }) => {
        if (!footer || (footer && footer.length === 0)) {
            return <View style={{
                marginBottom: 10,
            }} />
        }

        function onClick() {
            if (type === 'Contact') {
                navigation.replace("MoreChatContactSearch", { curSearch: searchText, data: users })
            } else if (type === 'GroupList') {
                navigation.replace("MoreChatGroupSearch", { curSearch: searchText, data: groups })
            } else if (type === 'Records') {
                navigation.replace("MoreChatMsgSearch", { curSearch: searchText, data: msgs })
            }
        }

        return (
            <View style={{
                backgroundColor: white,
                marginBottom: 10,
            }}>
                <Div />
                <Text onPress={onClick} style={[styles.header, { color: color_main }]}>{footer}</Text>
            </View>
        );
    }

    const navigSingleChat = (user: User) => {
        const tid = buildSingleTopicId(im.CurrentUid(), user.uid);
        const topic = findTopic(tid)
        if (topic) {
            const users: User[] = []
            if (user) {
                users.push(user)
            }
            if (state && state.user) {
                users.push(state.user as User)
            }
            topic.users = users
            toChatView(topic)
        } else {
            toSingleChat(user.uid, toChatView)
        }
        navigation.goBack()
    }

    const navigGroupChat = (group: Group) => {
        const topic = findTopic(group.tid)
        if (topic) {
            toChatView(topic)
        } else {
            ImSdk.getInstance().GetTopicDetail(group.tid).then((res) => {
                if (res.topic) {
                    toChatView(res.topic)
                }
            });
        }
        navigation.goBack()
    }


    const findTopic = (tid: string) => {
        let topic: TopicWithSummary | undefined
        if (state?.topicSummaryList.top) {
            const topics = state.topicSummaryList.top.filter(v => v.topic.tid === tid)
            if (topics.length > 0) {
                topic = topics[0]
            }
        }
        if (!topic && state?.topicSummaryList.normal) {
            const topics = state.topicSummaryList.normal.filter(v => v.topic.tid === tid)
            if (topics.length > 0) {
                topic = topics[0]
            }
        }
        return topic
    }
    const RenderUser = ({ subText, data }: { subText: string, data: any }) => {
        const user = data as User
        const name = getUserName(user)
        const left: Avatar = { avatar: user?.avatar, name: name, uid: user.uid };
        return (<Pressable
            onPress={() => navigSingleChat(user)}
            style={styles.userContainer}>
            <LeftView left={left} />
            {CommonText(name, subText)}
        </Pressable>)
    }
    const RenderGroup = ({ subText, data }: { subText: string, data: any }) => {
        const group = data as Group
        const name = group.remark || group.name || Str_GroupChat
        const left: Avatar = { avatar: group?.avatar, name: '', uid: group.uid };
        return (<Pressable
            onPress={() => navigGroupChat(group)}
            style={styles.userContainer}>
            <LeftView left={left} size={50} isRounded={true} isGroup={true} />
            {CommonText(name, subText)}
        </Pressable>)
    }
    const RenderRecords = ({ subText, data }: { subText: string, data: any }) => {
        const record = data as { tid: string, data: any }
        const tid = record.tid
        const isGroup = isGroupTopic(tid)
        let name = ''
        let avatar = ''
        let isAdmin = false
        let uid = 0
        if (isGroup) {
            const group = record.data as Group
            name = group.remark || group.name || Str_GroupChat
            avatar = group.avatar
            if (group?.adminUids) {
                const curUid = im.CurrentUid();
                if (curUid !== 0 && group.adminUids.includes(curUid)) {
                    isAdmin = true;
                }
            }
        } else {
            const user = record.data as User
            name = getUserName(user)
            avatar = user.avatar
            uid = user.uid;
        }
        const left: Avatar = { avatar: avatar, name: name, uid: uid };

        const onClick = () => {
            navigation.navigate('SearchChatResultScreen', { tid: tid, isAdmin: isAdmin, curSearch: searchText })
        };
        return (<Pressable
            onPress={onClick}
            style={styles.userContainer}>
            <LeftView left={left} size={40} isRounded={true} isGroup={isGroup} />
            {CommonText(name, subText)}
        </Pressable>)
    }
    const RenderItem = (type: string, item: { subText: string, data: any }) => {
        if (type === 'Contact') {
            return (<RenderUser data={item.data} subText={item.subText} />)
        }
        if (type === 'GroupList') {
            return <RenderGroup data={item.data} subText={item.subText} />
        }
        if (type === 'Records') {
            return <RenderRecords data={item.data} subText={item.subText} />
        }
        return null
    }
    // 渲染底部加载提示  
    const ListFooterComponent = () => (
        <View style={{ padding: 20, alignItems: 'center' }}>
            {isLoading && <ActivityIndicator size="large" color="#0000ff" />}
        </View>
    );
    return (<ScreenCloseModal >
        <ChatSearchInput searchText={searchText} onChangeText={onChangeText} />
        <SectionList
            style={{ marginTop: 16 }}
            sections={section}
            keyExtractor={(item, index) => index.toString()}
            renderItem={({ section, item }) => {
                return RenderItem(section.type, item)
            }}
            ItemSeparatorComponent={Div}
            renderSectionFooter={SectionFooter}
            keyboardDismissMode="on-drag"
            ListEmptyComponent={() => {
                if (!searchText || searchText.length === 0) {
                    return null
                }
                return <ListEmpty />
            }}
            ListFooterComponent={ListFooterComponent}
            renderSectionHeader={({ section }) => (<SectionHeader title={section.title} />)} />
    </ScreenCloseModal>)
}
const styles = StyleSheet.create({
    header: {
        fontSize: 13,
        marginStart: 16,
        paddingVertical: 8,
        color: "#737373"
    },
    userContainer: {
        flexDirection: "row",
        backgroundColor: white,
        paddingVertical: 8,
        paddingHorizontal: 12,
        alignItems: "center",
    },
    userTitle: {
        color: color_333333,
        fontSize: 14,
        width: '100%',
        fontWeight: 'bold',
        fontFamily: '',
    },
    subUserTitle: {
        color: color_999999,
        width: '100%',
        fontSize: 12,
    },
})